/* Hazii Studios — luxe layer: lazy adaptive video, reveal animations, header offset fix */
(function () {
	var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
	var lowData = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
	var GESTURES = ['touchend', 'click', 'keydown'];
	var armed = false;
	var pending = [];
	var loadIO = null;
	var playIO = null;
	var revealIO = null;

	window.hzLuxe = true;

	function shown(el) {
		return el.getClientRects().length > 0 && el.offsetWidth > 0;
	}

	/* ---------- Video: attach the right rendition only when needed ---------- */
	function pickSource(v) {
		var list = (v.getAttribute('data-hz-srcs') || '').split(',').filter(Boolean).map(function (x) {
			var i = x.indexOf('|');
			return { w: parseInt(x.slice(0, i), 10) || 0, u: x.slice(i + 1) };
		}).sort(function (a, b) { return a.w - b.w; });
		if (!list.length) return null;
		/* Background loops are soft by nature: 1.5x density is plenty, and phones never need 1080p. */
		var need = v.getBoundingClientRect().width * 1.5 * 0.5;
		if (window.innerWidth < 750) need = Math.min(need, 400);
		for (var i = 0; i < list.length; i++) if (list[i].w >= need) return list[i].u;
		return list[list.length - 1].u;
	}

	function attach(v) {
		if (v._hzSrc || lowData || reduce || !shown(v)) return false;
		var u = pickSource(v);
		if (!u) return false;
		v._hzSrc = u;
		v.setAttribute('preload', 'metadata');
		v.src = u;
		return true;
	}

	function onGesture() {
		armed = false;
		GESTURES.forEach(function (t) { document.removeEventListener(t, onGesture, true); });
		var list = pending.slice();
		pending = [];
		list.forEach(tryPlay);
	}

	function arm(v) {
		if (pending.indexOf(v) === -1) pending.push(v);
		if (armed) return;
		armed = true;
		GESTURES.forEach(function (t) { document.addEventListener(t, onGesture, { capture: true, passive: true }); });
	}

	var mobile = window.matchMedia('(max-width: 749px)');

	function pauseOthers(keep) {
		if (!mobile.matches) return;
		document.querySelectorAll('video[data-hz-autoplay]').forEach(function (o) { if (o !== keep && !o.paused) o.pause(); });
	}

	function tryPlay(v) {
		if (reduce || lowData || document.hidden || !v._hzIn || !shown(v) || !v.paused) return;
		if (mobile.matches && v._hzRatio !== undefined) {
			var best = true;
			document.querySelectorAll('video[data-hz-autoplay]').forEach(function (o) { if (o !== v && o._hzIn && (o._hzRatio || 0) > v._hzRatio) best = false; });
			if (!best) return;
		}
		pauseOthers(v);
		attach(v);
		if (!v._hzSrc) return;
		v.muted = true;
		var p = v.play();
		if (p && p.catch) p.catch(function () { arm(v); });
	}

	function bindVideos(scope) {
		var vids = (scope || document).querySelectorAll('video[data-hz-autoplay]');
		if (!vids.length) return;
		if (!loadIO && 'IntersectionObserver' in window) {
			/* Fetch shortly before a video scrolls into view ... */
			loadIO = new IntersectionObserver(function (entries) {
				entries.forEach(function (e) {
					if (e.isIntersecting && attach(e.target)) loadIO.unobserve(e.target);
				});
			}, { rootMargin: '300px 0px' });
			/* ... but only decode/play while it is meaningfully on screen. */
			playIO = new IntersectionObserver(function (entries) {
				entries.forEach(function (e) {
					var v = e.target;
					v._hzRatio = e.intersectionRatio;
					v._hzIn = e.isIntersecting && e.intersectionRatio >= 0.2;
					if (v._hzIn) tryPlay(v);
					else if (!v.paused) v.pause();
				});
			}, { threshold: [0, 0.2, 0.5, 0.8] });
		}
		vids.forEach(function (v) {
			if (v._hzBound) return;
			v._hzBound = true;
			v.muted = true;
			v.playsInline = true;
			if (loadIO) { loadIO.observe(v); playIO.observe(v); } else v._hzIn = true;
			v.addEventListener('canplay', function () { tryPlay(v); }, { once: true });
			v.addEventListener('playing', function () {
				var m = v.closest('.hz-media');
				if (m) m.classList.add('is-playing');
			}, { once: true });
		});
	}

	function playAll() {
		document.querySelectorAll('video[data-hz-autoplay]').forEach(tryPlay);
	}

	/* ---------- Reveal ---------- */
	function bindReveal(scope) {
		var items = (scope || document).querySelectorAll('[data-hz-reveal]:not(.is-in)');
		if (!items.length) return;
		if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
			items.forEach(function (el) { el.classList.add('is-in'); });
			return;
		}
		if (!revealIO) {
			revealIO = new IntersectionObserver(function (entries) {
				entries.forEach(function (e) {
					if (e.isIntersecting) {
						e.target.classList.add('is-in');
						revealIO.unobserve(e.target);
					}
				});
			}, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
		}
		items.forEach(function (el) { revealIO.observe(el); });
	}

	/* ---------- Top of page: promo app bar + header offset ---------- */
	var promoRO = null;
	function promoOffset() {
		var bar = document.querySelector('.essential_countdown_annoucement_bar_wrapper');
		var h = bar && shown(bar) ? bar.getBoundingClientRect().height : 0;
		document.documentElement.style.setProperty('--hz-promo-h', Math.round(h) + 'px');
		if (bar && !promoRO && 'ResizeObserver' in window) {
			promoRO = new ResizeObserver(function () { promoOffset(); heroOffset(); });
			promoRO.observe(bar);
		}
	}

	function heroOffset() {
		document.querySelectorAll('.hz-hero').forEach(function (h) {
			var top = h.getBoundingClientRect().top + window.scrollY;
			h.style.setProperty('--hz-hero-offset', Math.max(0, Math.min(top, 260)) + 'px');
		});
	}

	function init(scope) {
		promoOffset();
		heroOffset();
		bindVideos(scope);
		bindReveal(scope);
	}

	if ('MutationObserver' in window) {
		var mo = new MutationObserver(function () {
			if (document.querySelector('.essential_countdown_annoucement_bar_wrapper')) { promoOffset(); heroOffset(); }
		});
		var startMO = function () { mo.observe(document.body, { childList: true }); };
		if (document.body) startMO(); else document.addEventListener('DOMContentLoaded', startMO);
		setTimeout(function () { mo.disconnect(); }, 15000);
	}

	var rt;
	window.addEventListener('resize', function () {
		clearTimeout(rt);
		rt = setTimeout(function () { promoOffset(); heroOffset(); playAll(); }, 200);
	});
	document.addEventListener('visibilitychange', function () {
		if (document.hidden) document.querySelectorAll('video[data-hz-autoplay]').forEach(function (v) { if (!v.paused) v.pause(); });
		else playAll();
	});
	document.addEventListener('click', function (e) {
		if (e.target.closest && e.target.closest('.announcement-bar__button-close, .essential_countdown_annoucement_bar_wrapper')) {
			setTimeout(function () { promoOffset(); heroOffset(); }, 450);
		}
	});
	document.addEventListener('shopify:section:load', function (e) { init(e.target); });
	window.addEventListener('load', function () { promoOffset(); heroOffset(); });

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
	else init();
})();
